<template>
  <div>
    <breadcrumbs
      :breadcrumb-items="breadcrumbItems"
    />
    <UserToolbar
      v-if="account && Object.keys(account).length !== 0"
      :account="account"
    />

    <LandingForm
      v-if="Object.keys(currentLanding).length"
      :landing="currentLanding"
    />
  </div>
</template>

<script>
import useJwt from '@/auth/jwt/useJwt'
import Breadcrumbs from '@/views/ui/breadcrumbs/Breadcrumbs.vue'
import UserToolbar from '@/views/dashboard/users/UserToolbar.vue'
import LandingForm from './LandingForm.vue'

export default {
  components: {
    LandingForm,
    Breadcrumbs,
    UserToolbar,
  },
  data() {
    return {
      breadcrumbItems: [],
      account: {},
      currentLanding: {},
    }
  },
  created() {
    this.getUserData()
  },
  methods: {
    setBreabcrumbs() {
      if (this.$route.params.userId !== undefined) {
        this.breadcrumbItems = [
          {
            text: 'users',
            to: '/users',
          },
          {
            text: this.account.name,
            to: `/users/${this.$route.params.userId}`,
          },
          {
            text: 'landings.list',
            to: `/users/${this.$route.params.userId}/landings`,
          },
          {
            text: this.currentLanding.title,
            active: true,
          },
        ]
      } else {
        this.breadcrumbItems = [
          {
            text: 'landings.list',
            active: true,
          },
        ]
      }
    },
    async getUserData() {
      const responseData = await useJwt.getUser(this.$route.params.userId)
      this.account = responseData.data.account || []
      this.getLanding()
    },
    async getLanding() {
      const responseData = await useJwt.getLandingPage(this.$route.params.landingId)
      this.currentLanding = responseData.data.landingpage
      this.setBreabcrumbs()
    },
  },
}

</script>
